import React, { useLayoutEffect, useState } from "react";
import "./index.scss";
function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
}

const BasicLayout = props => {
  const [width, height] = useWindowSize();

  return (
    <div className="basic-layout" style={{ height: `${height}px` }}>
      {props.children}
    </div>
  );
};

export default BasicLayout;
